import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
   public uas_front: string;
  public OrderManagement: string;
  public uasService: string;
  public backendINV: string;
  public NSIManagement: string;
  public landingPage: string;
  public host: string;
  public orderMan: string;
  public sessions: string;
  public auctions: string;
  public trading:string;
  public ppRedirectUrl: string;
  public ppUrl: string;
  public ecpby: string;

  constructor(private http: HttpClient) {}

  load() :Promise<any>  {
    const promise = this.http.get('./assets/config.json')
      .toPromise()
      .then((data: any) => {
        Object.assign(this, data);
        return data;
      });
    return promise;
  }
}
